// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__i0nkh","label":"Radio_label__2DLSz","checkMark":"Radio_checkMark__Pz9r6","disabled":"Radio_disabled__FAYpv"};